import { endOfMonth, format, isValid, parseISO, startOfMonth } from "date-fns";

export type HistoryDateRouteParams = {
  fromDate?: string | null;
  toDate?: string | null;
  devoteeId?: string | null;
};

export function isValidHistoryDate(value?: string | null) {
  const trimmed = String(value ?? "").trim();

  if (!/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) {
    return false;
  }

  const parsed = parseISO(trimmed);
  return isValid(parsed) && format(parsed, "yyyy-MM-dd") === trimmed;
}

export function getDefaultHistoryRange(today = new Date()) {
  return {
    fromDate: format(startOfMonth(today), "yyyy-MM-dd"),
    toDate: format(endOfMonth(today), "yyyy-MM-dd"),
  };
}

export function resolveHistoryRange(
  params?: HistoryDateRouteParams | null,
  today = new Date()
) {
  
  const defaults = getDefaultHistoryRange(today);

  const fromDate = isValidHistoryDate(params?.fromDate)
    ? String(params?.fromDate).trim()
    : defaults.fromDate;

  const toDate = isValidHistoryDate(params?.toDate)
    ? String(params?.toDate).trim()
    : defaults.toDate;

  const devoteeId = String(params?.devoteeId ?? "").trim() || null;

  return {
    fromDate,
    toDate,
    devoteeId,
    hasNavigationDates:
      isValidHistoryDate(params?.fromDate) ||
      isValidHistoryDate(params?.toDate),
  };
}